import { CHANGE_WORKSHOP, CHANGE_EDITTING, NEW_WORKSHOP } from './constants'

export const changeWorkshop = (workshop) => {
  return {
    type: CHANGE_WORKSHOP,
    workshop
  }
}

export const changeEditting = (editting) => {
  return {
    type: CHANGE_EDITTING,
    editting
  }
}

export const newWorkshop = (newWorkshopStatus) => {
  return {
    type: NEW_WORKSHOP,
    newWorkshopStatus
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Workshop/actions.js